import { storeToRefs } from 'pinia'
import { useTheme } from 'vuetify'
import { cookieRef, useLayoutConfigStore } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'
import { useAuthStore } from '@/@vxapp/Auth/useAuthStore'
import { Cookie } from '@/@vxapp/@Enums/Cookie'
import { useCookie } from '@/@core/composable/useCookie'

// SECTION Store
export const useConfigStore = defineStore('useConfigStore', () => {
  const authStore = useAuthStore()
  const userPreferencesCookie = useCookie(Cookie.UserPreferences)

  const userPreferences = computed(() => {
    return (
      authStore.userPreferences ?? userPreferencesCookie.value ?? themeConfig.app.userPreferences
    )
  })

  const userPreferredColorScheme = usePreferredColorScheme()
  const cookieColorScheme = cookieRef(Cookie.ColorScheme, 'light', false)

  watch(
    userPreferredColorScheme,
    val => {
      if (val !== 'no-preference') cookieColorScheme.value = val
    },
    { immediate: true }
  )

  if (!useCookie(Cookie.Theme).value) {
    useCookie(Cookie.Theme).value = themeConfig.app.theme
  }
  const theme = useCookie(Cookie.Theme)

  const isVerticalNavSemiDark = cookieRef(
    'isVerticalNavSemiDark',
    themeConfig.verticalNav.isVerticalNavSemiDark
  )

  const skin = cookieRef('skin', themeConfig.app.skin)

  // ℹ️ We need to use `storeToRefs` to forward the state
  const {
    isLessThanOverlayNavBreakpoint,
    appContentWidth,
    navbarType,
    isNavbarBlurEnabled,
    appContentLayoutNav,
    isVerticalNavCollapsed,
    footerType,
    isAppRTL,
  } = storeToRefs(useLayoutConfigStore())

  const { global } = useTheme()

  return {
    theme,
    isVerticalNavSemiDark,
    skin,

    // @layouts exports
    isLessThanOverlayNavBreakpoint,
    appContentWidth,
    navbarType,
    isNavbarBlurEnabled,
    appContentLayoutNav,
    isVerticalNavCollapsed,
    footerType,
    isAppRTL,
    userPreferences,
    themeStyle: global,
  }
})
// !SECTION
// SECTION Init
export const initConfigStore = () => {
  const userPreferredColorScheme = usePreferredColorScheme()
  const vuetifyTheme = useTheme()
  const configStore = useConfigStore()

  watch([() => configStore.theme, userPreferredColorScheme], () => {
    vuetifyTheme.global.name.value =
      configStore.theme === 'system'
        ? userPreferredColorScheme.value === 'dark'
          ? 'dark'
          : 'light'
        : configStore.theme
  })
  onMounted(() => {
    if (configStore.theme === 'system')
      vuetifyTheme.global.name.value = userPreferredColorScheme.value
  })
}
// !SECTION
